import { App } from 'vue'
import VueFinalModal from 'vue-final-modal'

export default {
  install(app: App<Element>): any {
    app.use(VueFinalModal as any)
  }
}
